module.exports = __webpack_public_path__ + "img/work-slide-02.39afdbe9.jpg";